import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Grid, Label } from "semantic-ui-react";

import type { CommunicationAgreement } from "models";

type AgreementsProps = {
  agreements: CommunicationAgreement[] | null;
  onSelectAgreement?: (agreement: CommunicationAgreement) => void;
};

export const Agreements = ({ agreements, onSelectAgreement }: AgreementsProps) => {
  if (!agreements?.length) return null;
  const { t } = useTranslation();

  return (
    <div className="info-section">
      <div className="section-header">{t("v8_agreements", "Agreements")}</div>
      <div className="section-content">
        <Grid>
          <Grid.Column width={16}>
            {agreements.map((item, key) => (
              <div className="agreements-label" key={key} onClick={() => (onSelectAgreement ? onSelectAgreement(item) : null)}>
                <Label>
                  <FontAwesomeIcon icon={faCheckSquare} className="i-green" />
                </Label>
                <span className="ml-10">{item.name}</span>
              </div>
            ))}
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
};
